import mixins from '@synergycms_core/less/mixins';

export default {
  selected: {},
  defaultStyle: {
    height: '100vh',
    width: '100%',
    '@media (max-width: 1300px)': {
      height: '100%'
    }
  },
  gmapMarkerText: {
    display: 'none',
    '&$selected': {
      display: 'block'
    }
  },
  gmapMarkerIcon: {
    left: '0',
    bottom: '100%',
    cursor: 'pointer',
    fill: '#000',
    marginLeft: '-23px',
    display: 'block',
    width: '46px',
    height: '60px',
    position:'absolute',
    '&:hover': {
      ...mixins.transition(),
      fill: data => data.mainColor
    },
    '&$selected': {
      fill: data => data.mainColor
    },
    '&:lang(ar)':{
      marginLeft:'0',
      marginRight:'-23px'
    }
  },
  tooltipPointer: {
    height: '20px',
    zIndex: '900',
    width: '20px',
    backgroundColor: '#fff',
    borderLeft: '1px solid #bdbbbb',
    borderBottom: '1px solid #bdbbbb',
    '&:lang(ar)':{
      borderLeft: "none",
      borderRight: "1px solid #bdbbbb"
    }
  }
};
